import type { ReactNode } from 'react';

type BlogContentProps = {
  children: ReactNode;
  narrow?: boolean;
};

export function BlogContent({ children, narrow = false }: BlogContentProps) {
  return (
    <div
      className={`blog-content ${narrow ? 'blog-content--narrow' : 'blog-content--wide'}`}
    >
      {children}
    </div>
  );
}
